import { render } from "./FormNotice.vue?vue&type=template&id=54482c2c&scoped=true"
import script from "./FormNotice.vue?vue&type=script&lang=js"
export * from "./FormNotice.vue?vue&type=script&lang=js"

import "./FormNotice.vue?vue&type=style&index=0&id=54482c2c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54482c2c"

export default script